import React, { Component } from "react";
import styled from "styled-components";
import { images } from "./_resources";
import { withTranslation, Trans } from "react-i18next";
import { clear, set, get, remove } from "services/storage";

// import { check_school_api, school_permissions_api_list } from "services/cms/api";

class layoutUnconnectedDashboard extends Component {
  constructor(props){
    super(props);
    this.user = get("session_user");
    this.school = get('school');
    this.child_props = props.children.props;
    this.state = {
      hideMenuRight: !!this.child_props.hideMenuRight,
      openMenu: false,
      menuGlobal: false
    }
  }

  componentWillReceiveProps(props){
    this.child_props = props.children.props;
  }


  handleOpenMenu = () => {
    this.setState({
      openMenu: true
    });
  };

  handleCloseMenu = () => {
    this.setState({
      openMenu: false
    });
  };

  render() {
    return (
      <LayoutUnconnectedDashboardStyle>
        <div className="pageContainer" style={{background: '#f0f0f0', padding: 0}}>
          {this.props.children}
        </div>
      </LayoutUnconnectedDashboardStyle>
    );
  }
};

const LayoutUnconnectedDashboardStyle = styled.div`
  .pageContainer{
    width: 100%;
    min-height:100vh;
    display: flex;
    flex-direction: column;
    background: rgb(245, 246, 250);
    padding: 75px 0px 0px 95px;
    &.to-top{
      padding: 80px 0 0 95px;
      .contentPage{
        top: 5px;  
      }
    }
    .contentPage{
      &.active{
        margin-right: 400px;
      }
    }
    @media (max-width: 1199px) {
      padding: 0;
      .contentPage {
        overflow-x: unset;
        &.active {
          margin-right: 0;
        }
      }
      .menuStatistics {
        position: fixed;
        left: 0;
        bottom: -25px;
        width: 95px;
        z-index: 100;
        img {
          width: 100%;
        }
      }
    }
    @media (max-width: 767px) {
      width: 100%;
    }
  }
}
@media (max-width: 1199px) {
  .menuStatistics {
    position: fixed;
    left: 0;
    bottom: -25px;
    width: 95px;
    z-index: 100;
    img {
      width: 100%;
    }
  }
}
`;

export default withTranslation("translations")(layoutUnconnectedDashboard);
